// extracted by mini-css-extract-plugin
export default {"failure":"CheckoutError_failure__OV6J7","searchLink":"CheckoutError_searchLink__1XHPZ"};